import React from "react"
import { Link } from "react-router-dom"
import WithSearch from "containers/WithSearch"
import { createRequest } from "utils/request-helper"
import {
  states,
  types,
  genders,
  years,
  months,
  days,
} from "utils/camp-parameters"
import { getAbbrFromState } from "utils/camper-utils"
import glamorous from "glamorous"
import { inputStyle } from "components/Form/FormFields/FieldParts/Input"
import style from "utils/style"

class UserCampSearch extends React.Component {
  state = {
    filters: [
      {
        name: "session dates",
        hidden: true,
        type: "datepicker",
        render: this.renderDatePicker.bind(this),
      },
      {
        name: "states",
        hidden: true,
        type: "checkbox",
        render: this.renderStates.bind(this),
      },
      {
        name: "gender",
        hidden: true,
        type: "checkbox",
        render: this.renderGenders.bind(this),
      },
      {
        name: "type",
        hidden: true,
        type: "checkbox",
        render: this.renderTypes.bind(this),
      },
      {
        name: "specialties",
        hidden: true,
        type: "checkbox",
        render: this.renderSpecialties.bind(this),
      },
      {
        name: "expertise",
        hidden: true,
        type: "checkbox",
        render: this.renderExpertises.bind(this),
      },
    ],
    specialties: [],
    expertises: [],
  }

  componentDidMount() {
    this.getSpecialties()
    this.getExpertises()
  }

  renderDatePicker(change) {
    return (
      <DatePickerContainer>
        <StartPicker>
          <PickerTitle>Start</PickerTitle>
          <PickerParts>
            <Year name="startYear" onChange={e => change(e)}>
              {years.map((year, i) => {
                return (
                  <option key={i} value={year}>
                    {year}
                  </option>
                )
              })}
            </Year>
            <Month name="startMonth" onChange={e => change(e)}>
              {months.map((month, i) => {
                return (
                  <option key={i} value={month.value}>
                    {month.display}
                  </option>
                )
              })}
            </Month>
            <Day name="startDay" onChange={e => change(e)}>
              {days.map((day, i) => {
                return (
                  <option key={i} value={day}>
                    {day}
                  </option>
                )
              })}
            </Day>
          </PickerParts>
        </StartPicker>
        <EndPicker>
          <PickerTitle>End</PickerTitle>
          <PickerParts>
            <Year name="endYear" onChange={e => change(e)}>
              {years.map((year, i) => {
                return (
                  <option key={i} value={year}>
                    {year}
                  </option>
                )
              })}
            </Year>
            <Month name="endMonth" onChange={e => change(e)}>
              {months.map((month, i) => {
                return (
                  <option key={i} value={month.value}>
                    {month.display}
                  </option>
                )
              })}
            </Month>
            <Day name="endDay" onChange={e => change(e)}>
              {days.map((day, i) => {
                return (
                  <option key={i} value={day}>
                    {day}
                  </option>
                )
              })}
            </Day>
          </PickerParts>
        </EndPicker>
      </DatePickerContainer>
    )
  }

  renderStates(change, hide) {
    return states.map((state, i) => (
      <FilterOption hide={hide} key={i}>
        <FilterOptionName>
          <Box
            name={"camp-state"}
            type="checkbox"
            value={state.name}
            onChange={e => change(e)}
          />
          {state.name}
        </FilterOptionName>
      </FilterOption>
    ))
  }

  renderGenders(change, hide) {
    return genders.map((gender, i) => {
      return (
        <FilterOption hide={hide} key={i}>
          <FilterOptionName>
            <Box
              name={"camp-gender"}
              type="checkbox"
              value={gender.value}
              onChange={e => change(e)}
            />
            {gender.display}
          </FilterOptionName>
        </FilterOption>
      )
    })
  }

  renderTypes(change, hide) {
    return types.map((type, i) => (
      <FilterOption hide={hide} key={i}>
        <FilterOptionName>
          <Box
            name={type.value}
            type="checkbox"
            value={type.isChecked}
            onChange={e => change(e)}
          />
          {type.display}
        </FilterOptionName>
      </FilterOption>
    ))
  }

  renderSpecialties(change, hide) {
    return this.state.specialties.length > 0
      ? this.state.specialties.map(specialty => (
          <FilterOption hide={hide} key={specialty.id}>
            <FilterOptionName>
              <Box
                name={"camp_specialty_ids"}
                type="checkbox"
                value={specialty.id}
                onChange={e => change(e)}
              />
              {specialty.attributes.name}
            </FilterOptionName>
          </FilterOption>
        ))
      : null
  }

  renderExpertises(change, hide) {
    return this.state.expertises.length > 0
      ? this.state.expertises.map(expertise => (
          <FilterOption hide={hide} key={expertise.id}>
            <FilterOptionName>
              <Box
                name={"camp_expertise_ids"}
                type="checkbox"
                value={expertise.id}
                onChange={e => change(e)}
              />
              {expertise.attributes.name}
            </FilterOptionName>
          </FilterOption>
        ))
      : null
  }

  renderCampResults(results) {
    return results.length > 0
      ? results.map((camp, i) => {
          let location =
            camp.attributes["camp-city"] +
            ", " +
            getAbbrFromState(camp.attributes["camp-state"])

          let isTopResult = i < 5 ? true : false

          return (
            <CampResult
              to={`/camps/${camp.id}`}
              key={camp.id}
              data-topResult={isTopResult}
            >
              <CampImage src={camp.attributes.logo} />
              <CampInfo>
                <CampResultHeader>
                  <CampName>{camp.attributes.name}</CampName>
                  <span>{location}</span>
                  <span>{camp.attributes["camp-gender"]}</span>
                </CampResultHeader>
                <span>{camp.attributes["description-full-campers"]}</span>
              </CampInfo>
            </CampResult>
          )
        })
      : null
  }

  getSpecialties() {
    createRequest(
      {
        method: "GET",
        route: `camp_specialties`,
      },
      response => {
        this.setState({
          specialties: response.data.data,
        })
      },
      error => {
        console.error(error)
      }
    )
  }

  getExpertises() {
    createRequest(
      {
        method: "GET",
        route: `camp_expertises`,
      },
      response => {
        this.setState({
          expertises: response.data.data,
        })
      },
      error => {
        console.error(error)
      }
    )
  }

  render() {
    return (
      <WithSearch
        title="Camp Search"
        route="camps"
        renderResults={this.renderCampResults.bind(this)}
        filters={this.state.filters}
      />
    )
  }
}

export default UserCampSearch

const CampResult = glamorous(Link)(
  {
    color: style.colors.almostBlack,
    textDecoration: "none",
    display: "flex",
    background: style.colors.veryLightGray,
    borderBottom: "5px solid " + style.colors.lightGray,
    padding: "3% 5% 3% 0",
    marginBottom: "5%",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: style.colors.lightMintGreen,
      borderBottomColor: style.colors.mintGreen,
    },
  },
  props => ({
    background: props["data-topResult"] && style.colors.lightYellow,
    borderBottomColor: props["data-topResult"] && style.colors.darkYellow,
  })
)

const CampName = glamorous.span({
  color: style.colors.almostBlack,
  fontSize: "1.2rem",
  [style.size.desktop]: {
    paddingBottom: "1rem",
  },
})

const CampImage = glamorous.img({
  width: "20%",
})

const CampInfo = glamorous.div({
  width: "80%",
  fontSize: "0.9rem",
  color: style.colors.gray55,
})

const CampResultHeader = glamorous.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "5%",
  [style.size.desktop]: {
    flexDirection: "column",
    alignItems: "initial",
  },
})

const FilterOption = glamorous.div(({ hide }) => ({
  transition: "all .1s",
  padding: hide ? 0 : "2% 0 2% 0",
  opacity: hide ? 0 : 1,
  display: "flex",
  alignItems: "center",
}))

const Box = glamorous.input({
  marginRight: "1rem",
})

const FilterOptionName = glamorous.label({
  fontSize: "0.9rem",
  "&:hover": {
    cursor: "pointer",
  },
})

const Year = glamorous.select({
  ...inputStyle,
  width: "25%",
  borderColor: style.colors.gray,
  margin: 0,
})

const Month = glamorous.select({
  ...inputStyle,
  width: "40%",
  borderColor: style.colors.gray,
  margin: 0,
})

const Day = glamorous.select({
  ...inputStyle,
  width: "25%",
  borderColor: style.colors.gray,
  margin: 0,
})

const DatePickerContainer = glamorous.div({
  display: "flex",
  flexDirection: "column",
})

const PickerParts = glamorous.div({
  display: "flex",
  justifyContent: "space-between",
  margin: "0.5rem 0 0.5rem 0",
})

const PickerTitle = glamorous.span({
  color: style.colors.stoneGray,
  fontStyle: "italic",
  fontSize: "0.9rem",
})

const StartPicker = glamorous.div({})

const EndPicker = glamorous.div({})



// WEBPACK FOOTER //
// ./src/scenes/User/UserCampSearch/index.js